import ChatWidgetProps from '@/widget/widgetPropsInterface';
import { isMobile } from 'react-device-detect';
import { getFontColor } from '@/lib/colors/colors';

export default function buildInitialState({ settings, channels }: ChatWidgetProps): object {
  const {
    mode, host, token, wsUrl, lang, position,
    color, logoUrl, textOnline, textOffline, userInfo,
    invitationText, templates, privatePolicyUrl, formFields, links,
  } = settings;
  return {
    settings: {
      host,
      token,
      wsUrl,
      lang,
      position,
      privatePolicyUrl,
      color,
      logoUrl,
      textOnline,
      textOffline,
      invitationText,
      formFields,
      isMobile,
      customTrigger: !!settings.userInfo.org_name,
      textColor: getFontColor(settings.color),
      quickAnswers: templates,
      channels,
      links,
    },
    initialState: {
      mode: 'main',
      open: mode === 'open',
      userId: parseInt(userInfo.user_id, 10) || null,
      accountId: parseInt(userInfo.account_id, 10) || null,
      orgName: userInfo.org_name || null,
    },
  };
}
